/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemContextRequest
 */
export interface SystemContextRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof SystemContextRequest
     */
    brands?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SystemContextRequest
     */
    channels?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemContextRequest
     */
    markets?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemContextRequest
     */
    agencyGroups?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemContextRequest
     */
    agencies?: Array<string> | null;
}

export function SystemContextRequestFromJSON(json: any): SystemContextRequest {
    return SystemContextRequestFromJSONTyped(json, false);
}

export function SystemContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemContextRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brands': !exists(json, 'brands') ? undefined : json['brands'],
        'channels': !exists(json, 'channels') ? undefined : json['channels'],
        'markets': !exists(json, 'markets') ? undefined : json['markets'],
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : json['agencyGroups'],
        'agencies': !exists(json, 'agencies') ? undefined : json['agencies'],
    };
}

export function SystemContextRequestToJSON(value?: SystemContextRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brands': value.brands,
        'channels': value.channels,
        'markets': value.markets,
        'agencyGroups': value.agencyGroups,
        'agencies': value.agencies,
    };
}


